mutation DepartmentGroupUpdate($input: DepartmentGroupUpdateInput!) {
  departmentGroupUpdate(input: $input) {
    departmentGroup {
      __typename
      id
      _rowTimestamp
      _isUpdatable
      _isDeletable
      name
      description
      isTravelDepartmentGroup
      departmentGroupItems(orderBy: DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC) {
        nodes {
          id
          _rowTimestamp
          _isUpdatable
          _isDeletable
          departmentId
          department {
            name
          }
        }
      }
    }
  }
}
